/*
 * @Description:
 * @Author: tao.zhu
 * @Date: 2018-09-14 09:32:31
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2020-04-01 15:44:30
 * element动态切换语言插件应如下方式载入
    Vue.use(ElementUI, {
      i18n: (key, value) => i18n.t(key, value)
    });
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import axios from 'axios';
import auth from './../../utils/index';
import { Locale } from 'vant'
// 引入vant英文语言包
import vantEnUS from 'vant/es/locale/lang/en-US'
// 引入vant中文语言包
import vantZhCN from 'vant/es/locale/lang/zh-CN'
// import en from './lang-pack/en.js';
import zhCN from './lang-pack/zh-CN.js';

Vue.use(VueI18n);
window.axios = axios;
const loadedLanguages = ['zh-CN'];

const i18n = new VueI18n({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
  },
});
/**
 *  全局修改语言包的状态。
 * @param {string} lang 语言包名
 * @returns {string} lang
 */
export function setI18nLanguage(lang) {
  // 后端在 定义国家代码是不标准，又无法全量修改，在前端做一下兼容。
  // 写死英文
  // lang = 'zh_CN';
  let langForCGI = lang;
  if (lang === 'zh-CN' || lang === 'zh-TW') {
    langForCGI = lang.replace('-', '_');
  }

  axios.defaults.headers.common['Accept-Language'] = langForCGI;
  Cookies.set('lang', lang);
  auth.setStorageByKey('PAI-language', langForCGI);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

/**
 *
 * 摘自http://kazupon.github.io/vue-i18n/guide/lazy-loading.html
 * @export {function} 动态切换语言包
 * @param {string} lang 语言包名
 * @returns {promise} reslove lang.
 */
export function loadLanguageAsync(lang) {
  // lang ='zh_CN';
  if (lang === 'zh_CN' || lang === 'zh_TW') {
    lang = lang.replace('_', '-');
  }
  if (lang === 'zh-CN') {
    // 使用 vant中文语言包
    Locale.use('zh-CN', vantZhCN)
  }else if(lang === 'en'){
    // 使用 vant英文语言包
    Locale.use('en-US', vantEnUS)
  }
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      setI18nLanguage(lang);
      const arr = import(`./lang-pack/${lang}`);
      window.console.log(arr);
      return import(`./lang-pack/${lang}`).then((msgs) => {
        i18n.setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);
        i18n.locale = lang;
        return lang;
      }).catch((err) => {
        window.console.log(err);
      });
    }
    setI18nLanguage(lang);
    i18n.locale = lang;
    return Promise.resolve(lang);
  }
  setI18nLanguage(lang);
  i18n.locale = lang;
  return Promise.resolve(lang);
}

//const currentLang = auth.getStorageByKey('PAI-language') || Cookies.get('lang');
const currentLang='en';
// debugger
if (currentLang) {
  loadLanguageAsync(currentLang);
} else {
  // 默认
  setI18nLanguage('zh-CN');
  i18n.locale = 'zh-CN';
}

export default i18n;

